<app-modal [isOpen]="isOpen" (close)="cerrar()" className="max-w-lg mx-4">
  <div class="p-6 space-y-4">
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">{{ titulo }}</h2>

    @if (error) {
      <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
        {{ error }}
      </div>
    }

    <!-- ====== REOPEN ====== -->
    @if (action === 'reopen') {
    <div class="space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Razón (opcional)</label>
        <textarea [(ngModel)]="reopenReason" rows="3"
          placeholder="Motivo de la reapertura..."
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado al que vuelve <span class="text-gray-400">(default NEW)</span>
        </label>
        <select [(ngModel)]="reopenIdStatus"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="null">Default del business</option>
          @for (s of statuses; track s.id) {
            @if (!s.isResolved && !s.isTerminal) {
              <option [ngValue]="s.id">{{ s.label }}</option>
            }
          }
        </select>
      </div>
    </div>
    }

    <!-- ====== ESCALATE ====== -->
    @if (action === 'escalate') {
    <div class="space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Usuario destino <span class="text-error-500">*</span>
        </label>
        <app-entity-select
          [value]="escalateIdUserTo"
          [searchFn]="userSearchFn"
          [labelFn]="userLabelFn"
          [sublabelFn]="userSublabelFn"
          [idFn]="userIdFn"
          [allowClear]="true"
          placeholder="Buscar usuario por nombre o correo…"
          (valueChange)="escalateIdUserTo = $event"></app-entity-select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Razón <span class="text-error-500">*</span>
        </label>
        <textarea [(ngModel)]="escalateReason" rows="3"
          placeholder="Motivo de la escalación..."
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
      </div>
    </div>
    }

    <!-- ====== RESOLVE ====== -->
    @if (action === 'resolve') {
    <div class="space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Solución aplicada <span class="text-error-500">*</span>
        </label>
        <textarea [(ngModel)]="resolveSolution" rows="4"
          placeholder="Describa cómo se resolvió el ticket..."
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Causa raíz <span class="text-error-500">*</span>
        </label>
        <select [(ngModel)]="resolveIdRootCause"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="null">Seleccione una causa raíz</option>
          @for (rc of rootCauses; track rc.id) {
            <option [ngValue]="rc.id">{{ rc.name }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado terminal <span class="text-gray-400">(default primer is_resolved=true)</span>
        </label>
        <select [(ngModel)]="resolveIdStatus"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="null">Default del business</option>
          @for (s of statuses; track s.id) {
            @if (s.isResolved) {
              <option [ngValue]="s.id">{{ s.label }}</option>
            }
          }
        </select>
      </div>
    </div>
    }

    <!-- ====== SUB-TICKET ====== -->
    @if (action === 'sub-ticket') {
    <div class="space-y-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Asunto del sub-ticket <span class="text-error-500">*</span>
        </label>
        <input type="text" [(ngModel)]="subTicketSubject" maxlength="255"
          placeholder="Asunto..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Descripción</label>
        <textarea [(ngModel)]="subTicketDescription" rows="3"
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Prioridad</label>
          <select [(ngModel)]="subTicketIdPriority"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option [ngValue]="null">Heredar del padre</option>
            @for (p of priorities; track p.id) {
              <option [ngValue]="p.id">{{ p.label }}</option>
            }
          </select>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Categoría</label>
          <select [(ngModel)]="subTicketIdCategory"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option [ngValue]="null">Heredar del padre</option>
            @for (c of categories; track c.id) {
              <option [ngValue]="c.id">{{ c.name }}</option>
            }
          </select>
        </div>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Asignado a <span class="text-gray-400">(opcional)</span>
        </label>
        <app-entity-select
          [value]="subTicketIntIdUserOwner"
          [searchFn]="userSearchFn"
          [labelFn]="userLabelFn"
          [sublabelFn]="userSublabelFn"
          [idFn]="userIdFn"
          [allowClear]="true"
          placeholder="Buscar usuario por nombre o correo…"
          (valueChange)="subTicketIntIdUserOwner = $event"></app-entity-select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Notas internas</label>
        <textarea [(ngModel)]="subTicketNotes" rows="2"
          placeholder="Notas sobre el vínculo... usa @ para mencionar a alguien"
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
        <div class="mt-2">
          <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
            Mencionar usuario en las notas
          </label>
          <app-entity-select
            #mentionSelect
            [value]="null"
            [searchFn]="userSearchFn"
            [labelFn]="userLabelFn"
            [sublabelFn]="userSublabelFn"
            [idFn]="userIdFn"
            [allowClear]="true"
            placeholder="Elegir usuario para insertar @mención…"
            (selected)="insertMention($event)"></app-entity-select>
        </div>
      </div>
    </div>
    }

    <!-- ====== MERGE ====== -->
    @if (action === 'merge') {
    <div class="space-y-3">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Este ticket ({{ ticket?.ticketNumber || ticket?.subject }}) será el ticket primario; los demás se cierran y fusionan.
      </p>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Tickets a fusionar <span class="text-error-500">*</span>
        </label>

        @if (loadingSubTickets) {
          <div class="flex justify-center py-4">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-brand-500"></div>
          </div>
        } @else if (subTicketsLoadError) {
          <!-- Inc 53: sin la respuesta no sabemos si el ticket es padre → no se ofrece
               la búsqueda global; el usuario debe reintentar. -->
          <div class="rounded-lg border border-error-200 dark:border-error-500/20 bg-error-50 dark:bg-error-500/10 px-3 py-3">
            <p class="text-xs text-error-700 dark:text-error-400">
              No se pudieron cargar los subtickets de este ticket. No es posible elegir tickets a fusionar hasta que la carga funcione.
            </p>
            <button type="button" (click)="loadParentSubTickets()"
              class="mt-2 px-2.5 py-1 text-xs rounded-lg border border-error-300 dark:border-error-500/40 text-error-700 dark:text-error-400 hover:bg-error-100 dark:hover:bg-error-500/20">
              Reintentar
            </button>
          </div>
        } @else if (mergeUseSubTickets) {
          <!-- Inc 53: ticket padre → sólo se ofrecen sus subtickets -->
          <p class="text-xs text-gray-400 mb-2">
            Este ticket es un ticket padre: sólo puedes fusionar sus subtickets.
          </p>
          <div class="max-h-52 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-700">
            @for (sub of parentSubTickets; track sub.id) {
              <label class="flex items-start gap-2 px-2.5 py-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800">
                <input type="checkbox"
                  [checked]="isSubTicketSelected(sub.id)"
                  (change)="toggleSubTicket(sub)"
                  class="mt-0.5 h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-brand-500 focus:ring-brand-500" />
                <span class="min-w-0 flex-1">
                  <span class="flex items-center gap-2 text-xs">
                    <span class="font-mono text-brand-500 dark:text-brand-400 flex-shrink-0">{{ sub.ticketNumber }}</span>
                    @if (sub.statusName) {
                      <span class="px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300">{{ sub.statusName }}</span>
                    }
                  </span>
                  <span class="block text-sm text-gray-700 dark:text-gray-300 truncate">{{ sub.subject }}</span>
                </span>
              </label>
            }
          </div>
        } @else {
          <!-- INC 38: búsqueda global cuando el ticket no es un padre con subtickets -->
          <app-entity-select
            #mergeSelect
            [value]="null"
            [searchFn]="mergeSearchFn"
            [labelFn]="mergeTicketLabelFn"
            [sublabelFn]="mergeTicketSublabelFn"
            [idFn]="mergeTicketIdFn"
            [minChars]="1"
            [allowClear]="true"
            placeholder="Buscar por número o asunto…"
            (selected)="addMergeTicket($event)"></app-entity-select>

          @if (mergeSelected.length > 0) {
            <div class="flex flex-wrap gap-1.5 mt-2">
              @for (t of mergeSelected; track t.id) {
                <span class="inline-flex items-center gap-1.5 pl-2 pr-1 py-1 rounded-md bg-brand-50 text-brand-700 dark:bg-brand-900/30 dark:text-brand-300 text-xs">
                  <span class="font-mono text-brand-500 dark:text-brand-400">{{ t.ticketNumber }}</span>
                  <span class="max-w-40 truncate">{{ t.subject }}</span>
                  <button type="button" (click)="removeMergeTicket(t.id)"
                    class="p-0.5 rounded hover:bg-brand-100 dark:hover:bg-brand-900/50 hover:text-red-500"
                    title="Quitar">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </span>
              }
            </div>
          } @else {
            <p class="text-xs text-gray-400 mt-1">Busque y elija los tickets que se cerrarán y fusionarán en este.</p>
          }
        }
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Razón (opcional)</label>
        <textarea [(ngModel)]="mergeReason" rows="2"
          placeholder="Motivo registrado en el audit log..."
          class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>
      </div>
    </div>
    }

    <!-- ====== SPLIT ====== -->
    @if (action === 'split') {
    <div class="space-y-3">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        Defina al menos 2 partes. Cada parte se crea como ticket nuevo.
      </p>

      @for (part of splitParts; track $index; let i = $index) {
        <div class="rounded-lg border border-gray-200 dark:border-gray-700 p-3 space-y-2">
          <div class="flex items-center justify-between">
            <span class="text-xs font-semibold text-gray-700 dark:text-gray-300">Parte {{ i + 1 }}</span>
            @if (splitParts.length > 2) {
              <button type="button" (click)="removerParte(i)"
                class="text-xs text-error-500 hover:text-error-700">Quitar</button>
            }
          </div>
          <input type="text" [(ngModel)]="part.subject" placeholder="Asunto..."
            maxlength="255"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
          <textarea [(ngModel)]="part.description" rows="2" placeholder="Descripción (opcional)..."
            class="w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"></textarea>

          <div>
            <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
              Comentarios a mover a esta parte <span class="text-gray-400">(opcional)</span>
            </p>
            @if (loadingComments) {
              <p class="text-xs text-gray-400 dark:text-gray-500">Cargando comentarios…</p>
            } @else if (ticketComments.length === 0) {
              <p class="text-xs text-gray-400 dark:text-gray-500">Este ticket no tiene comentarios.</p>
            } @else {
              <div class="max-h-40 overflow-y-auto rounded-lg border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-700">
                @for (c of ticketComments; track c.id) {
                  <label class="flex items-start gap-2 px-2.5 py-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800">
                    <input type="checkbox"
                      [checked]="isCommentSelected(part, c.id)"
                      (change)="toggleComment(part, c.id)"
                      class="mt-0.5 h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-brand-500 focus:ring-brand-500" />
                    <span class="min-w-0 flex-1">
                      <span class="flex items-center gap-2 text-xs font-medium text-gray-700 dark:text-gray-300">
                        <span class="truncate">{{ c.authorName || 'Cliente' }}</span>
                        <span class="text-gray-400 dark:text-gray-500 font-normal">{{ c.datetimeCreated | date:'short' }}</span>
                      </span>
                      <span class="block text-xs text-gray-500 dark:text-gray-400 truncate">
                        {{ (c.bodyText || '') | slice:0:120 }}{{ (c.bodyText || '').length > 120 ? '…' : '' }}
                      </span>
                    </span>
                  </label>
                }
              </div>
            }
          </div>
        </div>
      }

      <button type="button" (click)="agregarParte()"
        class="text-xs text-brand-500 hover:text-brand-700">+ Agregar parte</button>
    </div>
    }

    <!-- Footer -->
    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <button type="button" (click)="cerrar()"
        class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Cancelar
      </button>
      @switch (action) {
        @case ('reopen') {
          <button type="button" (click)="ejecutarReopen()" [disabled]="saving"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Reabriendo… } @else { Reabrir }
          </button>
        }
        @case ('escalate') {
          <button type="button" (click)="ejecutarEscalate()"
            [disabled]="saving || escalateIdUserTo == null || !escalateReason.trim()"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Escalando… } @else { Escalar }
          </button>
        }
        @case ('resolve') {
          <button type="button" (click)="ejecutarResolve()" [disabled]="saving"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-green-600 text-white hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Resolviendo… } @else { Resolver }
          </button>
        }
        @case ('sub-ticket') {
          <button type="button" (click)="ejecutarSubTicket()" [disabled]="saving"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Creando… } @else { Crear sub-ticket }
          </button>
        }
        @case ('merge') {
          <button type="button" (click)="ejecutarMerge()" [disabled]="saving || mergeSelected.length === 0"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Fusionando… } @else { Fusionar }
          </button>
        }
        @case ('split') {
          <button type="button" (click)="ejecutarSplit()" [disabled]="saving"
            class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (saving) { Dividiendo… } @else { Dividir }
          </button>
        }
      }
    </div>
  </div>
</app-modal>
